// ─── Delivery fee model ──────────────────────────────────────────────────────
// Orders inside Buruburu are free delivery. Everywhere else is charged a flat
// rate per km, using an approximate driving distance from Buruburu to each
// known Nairobi area. Distances are estimates — edit the table to tune pricing.

export const DELIVERY_BASE_AREA = 'Buruburu';
export const DELIVERY_RATE_PER_KM = 25; // KSh per km charged to the customer outside Buruburu
export const DELIVERY_COST_PER_KM = 15; // KSh internal cost per km (rider/fuel) — used to auto-estimate delivery cost
export const MPESA_TILL_NUMBER = '3370969'; // M-Pesa Buy Goods (pay before delivery)

// Approx km from Buruburu to each delivery area. Base area = 0 (free).
export const DISTANCE_FROM_BURUBURU: Record<string, number> = {
  Buruburu: 0,
  Dagoretti: 18,
  Eastleigh: 6,
  Embakasi: 9,
  Gigiri: 16,
  Gikomba: 5,
  Githurai: 16,
  Huruma: 9,
  'Industrial Area': 8,
  Kahawa: 18,
  Kasarani: 13,
  Kayole: 7,
  Kibera: 15,
  Kileleshwa: 13,
  Koinange: 7,
  Komarock: 9,
  Langata: 17,
  Majengo: 5,
  Mathare: 7,
  'Mombasa Road': 11,
  Mukuru: 9,
  'Ngong Road': 14,
  Parklands: 10,
  Pipeline: 9,
  Pumwani: 5,
  Ruai: 18,
  Ruaraka: 10,
  Roysambu: 14,
  'South B': 8,
  'South C': 10,
  Umoja: 5,
  Westlands: 11,
  Zimmerman: 15,
};

// Fallback km for any area not in the table (keeps the fee deterministic).
const DEFAULT_DISTANCE_KM = 12;

/** Distance in km from Buruburu for a given area. 0 for the base area. */
export function getDeliveryDistanceKm(area: string): number {
  if (!area || area === DELIVERY_BASE_AREA) return 0;
  return DISTANCE_FROM_BURUBURU[area] ?? DEFAULT_DISTANCE_KM;
}

/** Delivery fee in KSh. 0 inside Buruburu, else rate × km. */
export function computeDeliveryFee(area: string): number {
  return getDeliveryDistanceKm(area) * DELIVERY_RATE_PER_KM;
}

/** Estimated internal delivery cost in KSh, given a distance in km. */
export function estimateDeliveryCost(km: number): number {
  return Math.round((km || 0) * DELIVERY_COST_PER_KM);
}
